import React, { useState } from 'react';
import { Spinner } from '@fluentui/react';
import useAxios from 'axios-hooks';
import { useRouteMatch, useHistory } from 'react-router-dom';
import { useBoolean } from '@fluentui/react-hooks';
import CampaignTable from './CampaignTable';
import DeleteModal from '../../../Util/DeleteModal';
import ErrorComponent from '../../../Util/ErrorComponent';
import SuccessComponent from '../../../Util/SuccessComponent';

const CampaignList = () => {
    const history = useHistory();
    let { url } = useRouteMatch();
    const [selectedCampaignId, setSelectedCampaignId] = useState(undefined);
    const [selectedSlug, setSelectedSlug] = useState('');
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [showDeleteModal, { toggle: toggleDeleteModal }] = useBoolean(false);

    const [{ data, loading }, refetch] = useAxios('/internal/campaigns');

    if (loading) {
        return <Spinner className="absolute-center" label="Loading Campaigns..." />;
    }

    return (
        <>
            <SuccessComponent
                successMessage="Campaign Deleted."
                showSuccess={showSuccess}
                setShowSuccess={setShowSuccess}
            />
            <ErrorComponent
                errorMessage={errorMsg}
                showError={showError}
                setShowError={setShowError}
            />
            <CampaignTable
                items={data}
                loading={loading}
                createOnClick={() => history.push(`${url}/wizard`)}
                editOnClick={(id) => history.push(`${url}/${id}`)}
                deleteOnClick={(id, slug) => {
                    setSelectedCampaignId(id);
                    setSelectedSlug(slug || '');
                    toggleDeleteModal();
                }}
            />
            <DeleteModal
                showModal={showDeleteModal}
                toggleShowModal={toggleDeleteModal}
                onDelete={() => refetch()}
                setErrorMsg={setErrorMsg}
                setShowError={setShowError}
                setShowSuccess={setShowSuccess}
                deleteUrl={`internal/campaigns/${selectedCampaignId}`}
                resourceName={selectedSlug}
                resourceType="campaign"
                confirmationValue={selectedSlug || undefined}
            />
        </>
    );
};

export default CampaignList;
